/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <rect
          width="19"
          height="19"
          fill="#000"
          rx="9.5"
          className="icon-fill"/><path
          fill="#fff"
          d="M8.882,4.475 L9.882,4.475 L9.882,11.203 L8.882,11.203 L8.882,4.475 Z M9.417,14.275 C8.9569468,14.275 8.584,13.9002623 8.584,13.438 C8.584,12.9757377 8.9569468,12.601 9.417,12.601 C9.8770532,12.601 10.25,12.9757377 10.25,13.438 C10.25,13.9002623 9.8770532,14.275 9.417,14.275 Z"
          className="icon-color"/>
      </svg>

    );
  }
}

Icon.displayName = 'CircleWithExclamationPointFillIcon';

export default Icon;
